// extracted by mini-css-extract-plugin
export default {"header":"header-Tqac","space":"space-QRBv","title":"title-Ntls","firstAction":"firstAction-M8_8","lastAction":"lastAction-rBao","spaceActionIcon":"spaceActionIcon-FxQO"};